import "./UpdateContactInformationTemplate.html";
export var template: string = require('./UpdateContactInformationTemplate.html');

import ko = require('knockout');
import { PubSub, Subscriptions } from "Subscriptions";
import ValidateableViewModel from "ValidateableViewModel";
import UserService from "Services/UserService";
import ResourceUrlsService from "Services/ResourceUrlsService";
import UserContactInformationModel from "Models/User/UserContactInformationModel";
import ClientSession from "ClientSession";
import Access, { AccessTypes, FacilitySettings } from "Utils/Access";

const ImageFolder = "Profile";
const AvatarImage = "/Content/images/avatar-empty.png";


class UpdateContactInformationViewModel extends ValidateableViewModel {
    firstName: KnockoutObservable<string>;
    middleName: KnockoutObservable<string>;
    lastName: KnockoutObservable<string>;
    primaryPhone: KnockoutObservable<string>;
    secondaryPhone: KnockoutObservable<string>;
    eSigCredentials: KnockoutObservable<string>;
    emailAddress: KnockoutObservable<string>;
    sesDirectEmailAddress: KnockoutObservable<string>;
    profileImageName: KnockoutObservable<string>;
    profileImageUrl: KnockoutObservable<string>;
    hasProfileImage: KnockoutObservable<boolean>;
    imagePreview: KnockoutObservable<any>;
    imageUploadTrigger: KnockoutObservable<any>;
    shouldRemoveImage: KnockoutObservable<boolean>;
    showProfileImageSecton: KnockoutObservable<boolean>;
    showSesDirectEmail: KnockoutObservable<boolean>;
    isIdpUser: KnockoutObservable<boolean>;

    profileImageNameSubscription: KnockoutSubscription;
    imagePreviewSubscription: KnockoutSubscription;

    cloudDataUrl: KnockoutObservable<string>;
    fileNameToUpload: KnockoutObservable<string>;
    userService: UserService;
    resourceUrlsService: ResourceUrlsService;
    uploadedFileName: KnockoutObservable<string>;

    showCancel: KnockoutObservable<boolean>;

    onSave: any;
    onCancel: any;

    constructor(params: any) {
        super();

        this.isIdpUser = ko.observable(false);

        if (typeof params.onSave === 'function') {
            this.onSave = params.onSave;
        }

        if (typeof params.onCancel === 'function') {
            this.onCancel = params.onCancel;
        }

        this.showCancel = ko.observable(true);

        if (typeof params.showCancel !== 'undefined' && params.showCancel !== null) {
            this.showCancel(params.showCancel);
        }

        this.firstName = ko.observable<string>().extend({
            required: true
        });

        this.middleName = ko.observable<string>();
        this.lastName = ko.observable<string>().extend({
            required: true
        });

        this.primaryPhone = ko.observable<string>();
        this.secondaryPhone = ko.observable<string>();
        this.eSigCredentials = ko.observable<string>();
        this.emailAddress = ko.observable<string>().extend({
            required: true,
            email: true
        });
        this.sesDirectEmailAddress = ko.observable<string>();

        this.profileImageName = ko.observable<string>("");
        this.profileImageNameSubscription = this.profileImageName.subscribe(this.updateProfileImage);
        this.hasProfileImage = ko.observable(false);
        this.imagePreview = ko.observable();
        this.imagePreviewSubscription = this.imagePreview.subscribe(this.imagePreviewChanged);
        this.imageUploadTrigger = ko.observable();
        this.shouldRemoveImage = ko.observable(false);
        this.showProfileImageSecton = ko.observable(true);


        this.showSesDirectEmail = ko.observable(false);
        Access.CheckFacilitySetting(FacilitySettings.DIRECT_EMAIL).then((data: boolean) => {
            if (data) {
                this.userService.checkDirectMessagingEnabled().then((data2: boolean) => {
                    if (!data2) {
                        this.showSesDirectEmail(false);
                    }
                    else {
                        this.showSesDirectEmail(true);
                    }
                });
            }
        });

        this.resourceUrlsService = new ResourceUrlsService();
        this.uploadedFileName = ko.observable<string>("");
        this.cloudDataUrl = ko.observable<string>("");
        this.fileNameToUpload = ko.observable<string>(ClientSession.user.userProfileImage);
        this.profileImageUrl = ko.observable<string>();

        this.setCloudProfileImageUrl(ClientSession.user.userProfileImage);

        if (typeof params.showProfileImageSection === 'boolean') {
            this.showProfileImageSecton(params.showProfileImageSection);
        }

        this.userService = new UserService();
        this.loadData();
    }

    setCloudProfileImageUrl = (imageName: string) => {
        if (typeof imageName === 'undefined' || imageName === null || imageName.trim() === '') {
            this.profileImageUrl(AvatarImage);
            return;
        }

        this.resourceUrlsService.getSharedResourceUrlRead(ImageFolder, imageName)
            .then(data => {
                if (typeof data === 'undefined' || data === null || data.trim() === '' || data === 'undefined')
                    this.profileImageUrl(AvatarImage);
                else
                    this.profileImageUrl(data);
            })
            .catch(() => { this.profileImageUrl(AvatarImage); });
    }

    cancelChanges = () => {
        this.loadData();
        this.imageUploadTrigger(null);
        this.imagePreview(null);

        this.setCloudProfileImageUrl(ClientSession.user.userProfileImage);
        this.shouldRemoveImage(false);
        this.onCancel();
    }

    saveChanges = () => {
        if (this.isValid()) {
            if (typeof this.imageUploadTrigger() === 'function' && !this.shouldRemoveImage()) {
                // We have an image to upload
                this.resourceUrlsService.getProfileImageUrlWrite(this.fileNameToUpload())
                    .then(data => {
                        if (data !== null) {
                            this.cloudDataUrl(data.url);
                            this.uploadedFileName(data.fileName);
                            this.imageUploadTrigger()();
                        }
                    });
            } else {
                // Either removing or just not uploading a new image
                if (this.shouldRemoveImage()) {
                    this.shouldRemoveImage(false);
                    this.userService.removeProfileImage().then(() => {
                        // Note: This is a hack to get the change notification to trigger so we get a "empty" image
                        ClientSession.user.userProfileImageUrl = this.profileImageUrl();
                        ClientSession.user.userProfileImage = this.profileImageName();
                    });
                }

                this.saveContactInformation();
            }
        }
    }

    registerSESDirectEmail = () => {
        $('#directMessagingRegisterModal').foundation('reveal', 'open');
    }

    chooseProfileImageCloud() {
        $('#profileImageChooserCloud').click();
    }

    onUploadComplete = () => {
        this.saveContactInformation();
        ClientSession.user.userProfileImageUrl = AvatarImage;
        ClientSession.user.userProfileImage = this.profileImageName();

        this.userService.updateProfileImage(this.profileImageName().split('.').pop());
        this.setCloudProfileImageUrl(this.profileImageName());
    }

    removeProfileImage() {
        this.profileImageName(AvatarImage);
        this.shouldRemoveImage(true);
        this.imagePreview(null);
        this.hasProfileImage(false);
    }

    dispose() {
        this.profileImageNameSubscription.dispose();
        this.imagePreviewSubscription.dispose();
    }

    private loadData = () => {
        this.userService.getContactInformation().then((data: UserContactInformationModel) => {
            this.firstName(data.firstName);
            this.middleName(data.middleName);
            this.lastName(data.lastName);
            this.primaryPhone(data.primaryPhone);
            this.secondaryPhone(data.secondaryPhone);
            this.eSigCredentials(data.eSigCredentials);
            this.emailAddress(data.emailAddress);
            this.sesDirectEmailAddress(data.sesDirectEmailAddress);
            this.hasProfileImage(data.hasProfileImage);
            this.isIdpUser(data.idpID !== null && data.idpID >= 0)
        });
    }

    private saveContactInformation() {
        var updatedData = <UserContactInformationModel>{
            firstName: this.firstName(),
            middleName: this.middleName(),
            lastName: this.lastName(),
            primaryPhone: this.primaryPhone(),
            secondaryPhone: this.secondaryPhone(),
            eSigCredentials: this.eSigCredentials(),
            emailAddress: this.emailAddress()
        };

        this.userService.saveContactInformation(updatedData).then(() => {
            this.onSave();
            PubSub.publish(Subscriptions.App.UpdateMenuName, {firstname: this.firstName(), lastName: this.lastName()});
        });
    }

    private updateProfileImage = () => {
        this.setCloudProfileImageUrl(this.profileImageName());

        this.hasProfileImage(true);
        this.shouldRemoveImage(false);
    }

    private imagePreviewChanged = () => {
        if (!this.imagePreview()) {
            return;
        }

        this.shouldRemoveImage(false);
    }
}

export var viewModel = UpdateContactInformationViewModel;